import React, { FC } from "react";
import {
  Container,
  PlanContainer,
  PlanIdentifier,
  PlanTittle,
  PlanValue,
  TopContainer,
  VetSaudeLogo,
  PlanSubValue,
} from "./Header.styles";
import CompraSegura from "./../../../Static/Images/100_segura.png";
import LogoVetSaude from "./../../../Static/Images/vet_saude.png";
import { IPlano } from "../../../Data/Interfaces/Request/Plano/IPlano";
import { History } from "history";
import { PlanosHelper } from "../../../Utils/Planos";
import moment from "moment";

export interface IHeader {
  showPlan: boolean;
  plano?: IPlano;
  history: History;
}

const Header: FC<IHeader> = ({ showPlan, plano, history }) => {
  return (
    <Container>
      <TopContainer>
        <img alt="Compra segura" src={CompraSegura} />
        <div />
      </TopContainer>
      <PlanContainer>
        <a onClick={() => history.push("/")}>
          <VetSaudeLogo alt="Quero Vet Saúde" src={LogoVetSaude} />
        </a>
        {showPlan && (
          <PlanIdentifier>
            <PlanTittle>{plano && plano.nome}</PlanTittle>
            <PlanValue>
              {plano && PlanosHelper.getPlanoVal(plano, "months")}
            </PlanValue>
            <PlanSubValue>
              {plano &&
                PlanosHelper.getPlanoVal(
                  plano,
                  plano.interval_type,
                  true,
                  plano.max_cycles === 0 ? 12 : plano.max_cycles + 1
                )}
            </PlanSubValue>
            {plano?.startAt && moment(plano.startAt).isAfter(new Date()) && (
              <PlanSubValue>
                Disponível para uso a partir de{" "}
                {moment(new Date(plano.startAt)).format("DD/MM/YYYY")}
              </PlanSubValue>
            )}
          </PlanIdentifier>
        )}
      </PlanContainer>
    </Container>
  );
};

export default Header;
